const onFailure = (error) => ({
  message: 'Administrador já cadastrado!',
  type: 'warning',
});

export default onFailure;
